import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import { useApi, useAuth } from 'hooks';
import { CareMemberAppointment } from 'models/careMemberAppointment';

type Props = {
  start_date?: string;
  end_date?: string;
  healthieId?: number;
};

export const useCareMemberAppointments = ({
  start_date,
  end_date,
  healthieId,
}: Props = {}) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchAppointments = async (): Promise<CareMemberAppointment[]> => {
    const queryStr = qs.stringify({ start_date, end_date });

    return await api({
      route: `/private/dashboard/care-team-member/${healthieId}/meetings${
        queryStr ? `?${queryStr}` : ''
      }`,
      token: userToken,
    });
  };

  const {
    data: appointments,
    isLoading,
    isError,
  } = useQuery<CareMemberAppointment[], Error>({
    queryKey: [
      'care-member-appointments',
      userToken,
      healthieId,
      start_date,
      end_date,
    ],
    queryFn: fetchAppointments,
    enabled: isAuthenticated && !loading && !!userToken && !!healthieId,
  });
  return {
    appointments,
    isLoading,
    isError,
  };
};

export default useCareMemberAppointments;
